import _ from 'lodash';

export class MetaController {
	constructor($scope, $location, searchService) {

		this.searchService = searchService;
		this.location = $location;
		this._initializeData();

		$scope.$watchCollection( () => {
			return searchService.getResults();
		}, () => {
			this._initializeData();
		});
	}

	update() {
		let routerBuilder = this.searchService.getRouteBuilder();
		this.location.search(routerBuilder.getRoute());
		this.searchService.query();
	}

	deselectFacet(facetId) {
		this.searchService.getFacet(facetId).selected = false;
		this.update();
	}

	_initializeData() {
		var pager = this.searchService.getPager();
		this.currentResults = pager.currentResults();
		this.totalResults = pager.totalResults;
		this.keywords = this.searchService.getFilter('q').getValue();
		this.selectedFacetGroups = this._getActiveFacetGroups();
	}

	_getActiveFacetGroups() {
		var groupsWithActive = [];
		_.each(this.searchService.getFacetGroups(), group => {
			if (group.getSelectedFacets().length) {
				groupsWithActive.push(group);
			}
		});

		return groupsWithActive;
	}


}

MetaController.$inject = ['$scope', '$location', 'searchService'];
